import _ from 'lodash';

import { ChangeKindFilter } from '../../PendingChangesDrawer.constants';

export const getDefaultExpandedSections = sections =>
  sections.reduce((acc, section) => {
    if (section.hasSubGroups) {
      return { ...acc, [section.name]: true };
    }

    return acc;
  }, {});

export const getTotalCount = counts => _.sum(Object.values(counts));

// Direct shows only the direct counts; Recalculated shows both, as its menu lists every section.
export const getVisibleKinds = selectedKind =>
  selectedKind === ChangeKindFilter.DIRECT
    ? [ChangeKindFilter.DIRECT]
    : [ChangeKindFilter.DIRECT, ChangeKindFilter.RECALCULATED];
